export const DEFAULT_API_ADMIN = import.meta.env.VITE_API_ADMIN || 'http://localhost:5000';

export const EXPIRED = 'timeout';
export const USER_KEY = 'user';
/**
 * Rede escolhida na barra por admin/revenda. Vive FORA do USER_KEY porque aquele blob
 * é do servidor: o authManager reescreve o perfil inteiro a cada renovação de token, e
 * `me.chainId` vem null para admin — a escolha ia junto.
 */
export const SELECTED_CHAIN_KEY = 'selected-chain';
export const GUID_REGEX = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/;
export const MAX_IDS_PER_REQUEST = 150;

export const PERMISSION_TYPE = {
  ADMIN: 'admin',
  PARTNER_MANAGER: 'partner-manager',
  PARTNER_OPERATOR: 'cashier',
  CHAIN_MANAGER: 'chain-manager',
  CHAIN_OPERATOR_MANAGER: 'chain-operator-manager',
  CHAIN_OPERATOR: 'chain-operator',
};

export const PERMISSIONS = {
  ADMIN: 'admin',

  // User
  CREATE_USER: 'create-user',
  UPDATE_USER: 'update-user',
  CREATE_LOCAL_USER: 'create-local-user',
  UPDATE_LOCAL_USER: 'update-local-user',
  MANAGE_ATTENDANT_USER: 'manage-attendant-user',

  // Customer
  LIST_CUSTOMER: 'list-customer',
  CREATE_CUSTOMER: 'create-customer',
  UPDATE_CUSTOMER: 'update-customer',
  ADD_POINTS: 'add-points',
  ADD_POINTS_BY_FUEL: 'add-points-by-fuel',
  EDIT_MAX_POINTS: 'edit-max-points',
  BLOCK_CUSTOMER: 'block-customer',
  REMOVE_ADDED_POINTS: 'remove-added-points',
  CUSTOMER_GROUPS: 'customer-groups',
  CUSTOMER_STATEMENT: 'customer-statement',
  TERMS_OF_USE: 'terms-of-use',
  CUSTOMERS_DELETED: 'customers-deleted',
  DEVICE: 'customer-device',
  GENERATE_CONFIRMATION_QRCODE: 'generate-confirmation-qrcode',

  // Partner
  CREATE_PARTNER: 'create-partner',
  UPDATE_PARTNER: 'update-partner',
  DELETE_PARTNER: 'delete-partner',

  //Station
  STATION_GROUPS: 'station-groups',
  LIST_STATION: 'list-stations',
  MANAGE_WHATSAPP_NUMBERS: 'manage-whatsapp-numbers',
  UPDATE_STATION: 'update-station',

  // Station Admin
  REGISTER_STATION_FINANCIAL: 'register-station-financial',
  REGISTER_STATION_GESTAO_CLICK: 'register-station-gestao-click',
  REGISTER_STATION_PAYMENT: 'register-station-payment',
  REGISTER_STATION_GPS: 'register-station-gps',
  REGISTER_STATION_SYNCHONIZATION: 'register-station-synchronization',
  REGISTER_STATION_IDENTIFICATION: 'register-station-identification',
  REGISTER_STATION_CONCENTRATOR: 'register-station-concentrator',
  REGISTER_STATION_ADDRESS: 'register-station-address',
  REGISTER_STATION_OPENING_HOURS: 'register-station-opening-hours',
  BILLING_ALERT: 'billing-alert',
  EXPIRATION_ALERT: 'expiration-alert',

  // Rede Admin
  REGISTER_CHAIN_MODULE: 'register-chain-module',

  //Attendant
  CREATE_ATTENDANT: 'create-attendant',
  LIST_ATTENDANT: 'list-attendant',
  DELETE_ATTENDANT: 'delete-attendant',
  UPDATE_ATTENDANT: 'update-attendant',

  // Product
  CREATE_PRODUCT: 'create-product',
  UPDATE_PRODUCT: 'update-product',
  DISABLE_PRODUCT: 'disable-product',
  UPDATE_FEATURED_PRODUCTS: 'update-featured-products',
  CREATE_PRODUCT_CATEGORIES: 'create-product-categories',
  FUEL_DISCOUNTS: 'fuel-discounts',
  FILLIN_CASHBACK: 'fillin-cashback',
  GIFT: 'gift',

  // Stock
  PRODUCT_ENTRY: 'product-entry',
  PRODUCT_WRITEOFF: 'product-writeoff',
  STOCK_ADJUSTMENT: 'stock-adjustment',
  STOCK_TRANSFER: 'stock-transfer',
  DELETE_STOCK_TRANSACTION: 'delete-stock-transaction',

  // Contact
  LIST_MESSAGES: 'list-messages',
  SEND_NOTIFICATION: 'send-notification',
  DELETE_NOTIFICATION: 'delete-notification',
  SEND_SMS: 'send-sms',
  LIST_RATINGS: 'list-ratings',
  RATING_POLL_ITEMS: 'rating-poll-items',
  ANSWER_RATING: 'answer-rating',

  // Profile
  CREATE_PROFILE: 'create-profile',
  UPDATE_PROFILE: 'update-profile',
  ADMIN_PROFILE: 'admin-profile',

  // Reports
  ADDED_POINTS_REPORT: 'added-points-report',
  ADVERTISEMENT_VIEWS_REPORT: 'advertisement-views-report',
  APPROVED_TRANSACTIONS_REPORT: 'approved-transactions-report',
  ATTENDANT_RATING_REPORT: 'attendant-rating-report',
  ATTENDANT_REPORT: 'attendant-report',
  BILLINGS_REPORT: 'billings-report',
  BLOCKED_CUSTOMERS_REPORT: 'blocked-customers-report',
  CLIENTS_GENERATED_POINTS_REPORT: 'clients-generated-points-report',
  COUPONS_REPORT: 'coupons-report',
  CUSTOMERS_WITHOUT_DRAWING_REPORT: 'customers-without-drawing-report',
  DEFAULT_POINTS_REPORT: 'default-points-report',
  DETAILED_POINTS_REPORT: 'detailed-points-report',
  PRODUCT_POINTS_REPORT: 'product-points-report',
  OPERATIONS_STATEMENT_REPORT: 'operations-statement-report',
  DEVICE_CUSTOMER_REPORT: 'device-customer-report',
  DEVICE_MANUFACTURER_REPORT: 'device-manufacturer-report',
  DISCOUNT_REPORT: 'discount-report',
  DOTZ_REFUEL_TRANSACTIONS_REPORT: 'dotz-refuel-transactions-report',
  DRAWING_REPORT: 'drawing-report',
  EXPIRED_POINTS_REPORT: 'expired-points-report',
  FAVORITE_STATION_REPORT: 'favorite-station-report',
  FILLINS_REPORT: 'fillins-report',
  FILLIN_BY_ATTENDANT_REPORT: 'fillin-by-attendant-report',
  FILLIN_BY_CUSTOMER_REPORT: 'fillin-by-customer-report',
  FILLIN_BY_FUEL_REPORT: 'fillin-by-fuel-report',
  FILLIN_BY_STATION_REPORT: 'fillin-by-station-report',
  FIRST_FILLIN_REPORT: 'first-fillin-report',
  FIXED_DISCOUNT_REPORT: 'fixed-discount-report',
  INACTIVE_CUSTOMERS_REPORT: 'inactive-customers-report',
  LIFE_POINTS_REPORT: 'life-points-report',
  LUCKY_NUMBER_REPORT: 'lucky-number-report',
  MINIMUM_STOCK_REPORT: 'minimum-stock-report',
  MONTHLY_EVOLUTION_REPORT: 'monthly-evolution-report',
  NEW_CUSTOMERS_BY_PROMOTERS_REPORT: 'new-customers-by-promoters-report',
  NEW_CUSTOMERS_REPORT: 'new-customers-report',
  NON_VALIDATED_COUPONS_REPORT: 'non-validated-coupons-report',
  NOTIFICATIONS_REPORT: 'notifications-report',
  PARTNERS_REPORT: 'partners-report',
  INVOICES_REPORT: 'invoices-report',
  STATIONS_WITHOUT_BILLS_REPORT: 'stations-without-bills-report',
  PARTNER_VALUES_REPORT: 'partner-values-report',
  PAYMENT_BY_PIX_REPORT: 'payment-by-pix-report',
  PENDING_TRANSACTION_REPORT: 'pending-transaction-report',
  POINTS_BALANCE_REPORT: 'points-balance-report',
  POINTS_REPORT: 'points-report',
  PRODUCTS_REPORT: 'products-report',
  PURCHASE_SUGGESTION_REPORT: 'purchase-suggestion-report',
  REAL_PRICE_REPORT: 'real-price-report',
  RECURRING_CUSTOMERS_REPORT: 'recurring-customers-report',
  REDEEMED_COUPONS_REPORT: 'redeemed-coupons-report',
  REDEEMED_PRODUCTS_REPORT: 'redeemed-products-report',
  REDEMPTION_X_POINTS: 'redemption-x-points',
  REFERED_CUSTOMERS_REPORT: 'refered-customers-report',
  REFUNDED_COUPONS_REPORT: 'refunded-coupons-report',
  REGISTERED_DISCOUNTS_REPORT: 'registered-discounts-report',
  REGISTRATION_CUSTOMERS_REPORT: 'registration-customers-report',
  SOLD_PRODUCTS_REPORT: 'sold-products-report',
  SCORING_REPORT: 'scoring-report',
  STATION_RATING_REPORT: 'station-rating-report',
  STATION_REPORT: 'station-report',
  STOCK_CHANGES_REPORT: 'stock-changes-report',
  STOCK_STATEMENT_REPORT: 'stock-statement-report',
  TOP_CUSTOMERS_REPORT: 'top-customers-report',
  RATING_POLL_ITEMS_REPORT: 'rating-poll-items-report',

  DELIVERIES_REPORT: 'deliveries-report',

  // REPORT ADMIN
  CONCENTRATOR_ERROR_REPORT: 'concentrator-error-report',
  SOCKET_ERROR_REPORT: 'socket-error-report',
  CURRENT_FILLINS_REPORT: 'current-fillins-report',
  EXTERNAL_PARTNERS_REPORT: 'external-partners-report',
  RETAILERS_REPORT: 'retailers-report',
  STATIONS_CTT_VALUE_REPORT: 'stations-ctt-value-report',
  ENTITY_CHANGE_LOG_REPORT: 'entity-change-log-report',

  // Access
  ACCESS_TOTEM: 'access-totem',
  ACCESS_RESGATE: 'access-resgate',

  // Cashier related
  VALIDATE_COUPON: 'validate-coupon',

  // Others
  REFUND_COUPON: 'refund-coupon',
  SETTINGS: 'settings',
  REPRINT_COUPON: 'reprint-coupon',
  COUPONS_CODE: 'coupons-code',
  CREATE_COUPON: 'create-coupon',
  DELETE_COUPON: 'delete-coupon',
  TAG: 'tag',
  // Importa CPFs na etiqueta sem cadastrar nem listar clientes (pedido ao dev #8). CREATE_CUSTOMER também importa.
  IMPORT_TAG_CPFS: 'import-tag-cpfs',

  //Marketing
  MARKETING_CAMPAIGNS: 'marketing-campaigns',
  UNIFIED_SEND: 'unified-send',
  DISPATCH_MESSAGE: 'dispatch-message',
  ADVERTISEMENT: 'advertisement',
  BULK_SEND: 'bulk-send',
  POP_UPS: 'pop-ups',

  // Attendant-targets
  ATTENDANT_TARGET: 'attendant-target',
  ATTENDANT_TARGET_MONITOR: 'attendant-target-monitor',
  ATTENDANT_GOAL_ACHIEVEMENT_REPORT: 'attendant-goal-achievement-report',

  //Pontuação
  SPECIAL_RULES: 'special-rules',
  RULES_BY_GROUP: 'rules-by-group',
  DEFAULT_POINTS: 'default-points',
  PENDING_POINTS: 'pending-points',
  MANAGE_COMPANY_WITHOUT_POINT: 'manage-company-without-point',
  IMPORT_POINTS: 'import-points',
  POINT_RULES: 'point-rules',
  DEFAULT_POINTS_FUEL: 'default-points-fuel',
  MINIMUM_AMOUNT_RULE: 'minimum-amount-rule',
  SCORINGS: 'scorings',

  // Security
  POTENCIAL_FRAUD_LIST: 'potencial-fraud-list',
  IGNORE_FRAUD_LOG: 'ignore-fraud-log',
  IGNORE_CUSTOMER_FRAUD_LOG: 'ignore-customer-fraud-log',
  RESOLVE_FRAUD_LOG: 'resolve-fraud-log',
  POTENCIAL_FRAUD_RULE: 'potencial-fraud-rule',
  LIST_CUSTOMERS_IGNORED: 'list-customers-ignored',

  //Dashboard
  ADITION_POINTS: 'adition-points',
  RANK_CUSTOMERS_ADDED_POINTS: 'rank-customers-added-points',
  RANK_ATTENDANTS: 'rank-attendants',
  GENERATED_REDEEMED_POINTS: 'generated-redeemed-points',
  FILLINS_AVERAGE_TIME: 'fillins-average-time',
  FILLIN_DURATION: 'fillin-duration',
  FILLINS_CHART: 'fillins-chart',
  FUEL_CHART: 'fuel-chart',
  FILLINS_BY_HOUR: 'fillins-by-hour',
  NEW_CUSTOMERS_CHART: 'new-customers-chart',
  WORD_CLOUD: 'word-cloud',
  REFEREE_COUNT: 'referee-count',

  // register
  CHAIN: 'chain',
  RETAILER: 'retailer',
  EXTERNAL_PARTNER: 'external-partner',
  PERMISSION_GROUP: 'permission-group',
  USER_PERMISSION: 'user-permission',
  PARENT_FUEL: 'parent-fuel',
  FUEL: 'fuel',
  DRAWING_RULE: 'drawing-rule',
  SERVICE: 'service',
  FUEL_PRICE: 'fuel-price',

  UNREDEEM_COUPON: 'unredeem-coupon',

  //Abastecimento
  LIST_FILLINS: 'list-fillins',

  //Abastecimento Admin
  EDIT_FILLIN: 'edit-fillin',

  //Abastecimento
  LIST_PAYMENTS: 'list-payments',
  VERIFY_PAYMENTS: 'verify-payments',

  //Sales
  LIST_SALES: 'list-sales',

  //drawing
  DRAWING: 'drawing',

  //billing
  BILLING: 'billing',
  BILLING_PAYMENT: 'billing-payment',

  //payments
  MANAGE_EXTERNAL_PAYMENT_METHOD: 'manage-external-payment-method',

  //Promoter
  CREATE_PROMOTER: 'create-promoter',
  LIST_PROMOTER: 'list-promoters',
  DELETE_PROMOTER: 'delete-promoter',
  UPDATE_PROMOTER: 'update-promoter',

  //App
  APP_LABEL: 'app-label',

  //Plan
  PLAN: 'plan',

  //News
  LIST_NEWS: 'list-news',

  //News Admin
  NEWS: 'news',

  //City
  CITY: 'city',

  // Support Agent
  USE_SUPPORT_AGENT: 'use-support-agent',

  // AI Report
  AI_REPORT: 'ai-report',

  // Comment Analysis
  COMMENT_ANALYSIS: 'comment-analysis',

  // Product Evolution Dashboard
  PRODUCT_EVOLUTION: 'product-evolution',

  // Dashboard 2.0 (Painel 360)
  DASHBOARD_V2: 'dashboard-v2',

  // Meta de Frentista (interno PontuaX): convites e execuções semanais
  ATTENDANT_GOAL_INTERNAL: 'attendant-goal-internal',

  // Pedidos ao dev (interno PontuaX): fila do worker que desenvolve e entrega pedidos do suporte
  DEV_REQUEST: 'dev-request',

  // AI Text Editor
  TEXT_EDITOR_AI: 'text-editor-ai',

  // Live Map
  LIVE_MAP_REPORT: 'admin',

  // Customer Recovery
  CUSTOMER_RECOVERY_RULES: 'customer-recovery-rules',
  CUSTOMER_RECOVERY_REPORT: 'customer-recovery-report',
} as const;

export const CUSTOMERS = 'customers';
export const MANAGER = 'manager';
export const PRODUCT = 'chains/chainId/products';
export const MONEY_PRODUCTS = 'money-products';
export const ADVERTISEMENTS = 'advertisements';
export const NOTIFICATION = 'notifications';
export const SMS = 'sms';
export const ADVERTISEMENTS_MAX_PAYLOAD_SIZE = 25 * 1024 * 1024;

export const chainIdDelete = [
  'chains',
  'chains/chainId/products',
  'money-products',
  'chains/chainId/partners',
  // Revogar sessão é por funcionário, não por rede: um chainId no corpo seria recusado
  // pelo Joi da rota (payload estrito).
  'employees/sessions/revoke-all',
];
// `money-products` entra aqui mesmo sem ter imagem: a rota POST /chains/{chainId}/products
// do backend declara `allow: 'multipart/form-data'` e recusa JSON com 415. Sem esta entrada,
// handlePayload não converte o payload em FormData e o body sai como objeto cru.
export const routesWithUpload = ['chains', 'chains/chainId/products', 'money-products', 'stations', 'chains/chainId/partners', 'chains/chainId/product-categories', 'services', 'billings', 'advertisements', 'retailers', 'gifts', 'pop-ups', 'partner-payments', 'home-carousel'];
export const clearMaskRoutes = ['chains', 'chains/chainId/partners', 'stations', 'customers'];

export const mapPath = {
  _employees: 'employees',
  'attendant-employees': 'employees',
  boloes: 'chains/chainId/boloes',
  // Produto em dinheiro é um Product com is_cash = true — mesmo endpoint, filtro diferente.
  'money-products': 'chains/chainId/products',
  // Relatório de recargas: o endpoint é escopado por rede, o nome do recurso é de relatório.
  'report-charge-sessions': 'chains/chainId/charge-sessions',
};

// dd/MM/yyyy hh:mm
export const DATE_FORMATER = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export const MAX_DATE = "9999-12-31";

export const frequencyChoices = [
  { id: 'never', name: 'Não se repete' },
  { id: 'daily', name: 'Diária' },
  { id: 'weekly', name: 'Semanal' },
];

export const daysOfTheWeek = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'].map((d, i) => ({ id: i, name: d }));

export const alterPriceTypes = {
  increase: 'Acréscimo',
  discount: 'Desconto',
}

export const alterPriceValueTypes = {
  cents: 'Centavos',
  percentage: 'Porcentagem',
  prefixed: 'Prefixado',
}

export const discountTypes = {
  default: 'Padrão',
  special: 'Especial',
  reward: 'Recompensa',
  recovery: 'Recuperação',
};

export const scoringTypes = {
  default: 'Padrão',
  special: 'Especial',
};

export const minimumValueCashbackToolTip = `Este valor será o limite mínimo para que seja possível que um usuário faça um
resgate de cashback no aplicativo. Deixe zerado para indicar que NÃO HÁ um limite`;

// Imagem da recompensa em dinheiro do Clube de Vantagens, usada na vitrine do app.
// No CUPOM ela não é usada: com is_cashback o app desenha o cartão de dinheiro com o valor
// e ignora o image_path — vale para build antigo também. Vazio = recompensa sem imagem.
export const CASHBACK_REWARD_IMAGE_URL = '';
